import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  Typography,
  Button,
  Grid,
  Icon,
  Divider,
  Card,
  Tabs,
  Tab
} from '@material-ui/core';
import {
  getSinglePromotionAPI,
  getSingleTemplateAPI
} from 'api';
import { Breadcrumb, BackdropCircular } from 'components';
import { FacebookShareButton } from 'react-share';
import { getSinglePromoSuccess } from 'redux/actions/promo';
import { shopManagerApi } from 'configs';
import MarkdownIt from 'markdown-it';
// import PrintPromoPdf from './PrintPromoPdf/PrintPromoPdf';//      we will work on new PDF generator in future


const md = new MarkdownIt();

const detailsTabs = [
  'Banners',
  'Social Images',
  // 'PDF'
];

const PromoDetails = () => {
  const {id: promoId, tabName} = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [tabIndex, setTabIndex] = useState(0);

  const {
    selectedPromo,
    loadingSinglePromo
  } = useSelector((state) => state.promo);

  useEffect(() => {
    const { pathname, state } = history.location;

    if (state?.promo) {
      dispatch(getSinglePromoSuccess({ promotion: state?.promo }));
    } else if (pathname.includes('promo-details')) {
      getSinglePromotionAPI({ dispatch, id: promoId });
    } else if (pathname.includes('template-details')) {
      getSingleTemplateAPI({ dispatch, id: promoId });
    }
  }, [promoId]);


  const handleTabChange = (e, value) => {
    setTabIndex(value);
  };

  const handleDownload = async (url) => {
    url = `${shopManagerApi}/assets/image?url=${url}`;

    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.click();
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y">
      <div className="mb-20">
        <Breadcrumb
          routeSegments={[
            { name: 'Automatic Promotions', path: `/my-promotions/${tabName}`},
            { name: 'Details'}
          ]}
        />

        <div className="m-10">
          <h5 className="font-normal mb-8 capitalize">
            <strong>{selectedPromo.promoName}</strong>
          </h5>
          <Divider />
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <Typography gutterBottom variant="body1" className="text-muted m-0">
                Start Date:
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="MM/dd/yyyy"
                  margin="normal"
                  autoOk
                  disabled
                  value={selectedPromo.startDate}
                  className="my-5"
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Divider />
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <Typography gutterBottom variant="body1" className="text-muted m-0">
                End Date:
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="MM/dd/yyyy"
                  margin="normal"
                  autoOk
                  disabled
                  value={selectedPromo.endDate}
                  className="my-5"
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Divider />
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <Typography gutterBottom variant="body1" className="text-muted m-0">
                Promotion Description:
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <div dangerouslySetInnerHTML={{ __html: md.render(selectedPromo?.promoDescription || '') }} />
            </Grid>
          </Grid>
          <Card elevation={25} className="p-8 mt-5">
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              className="mb-8"
            >
              {detailsTabs.map((tab, idx) => (
                <Tab
                  className="capitalize font-medium px-4"
                  key={`tab-${idx}`}
                  value={idx}
                  label={tab}
                />
              ))}
            </Tabs>
            {tabIndex === 0 &&
              <Grid container className="m-8">
                <Grid item md={12} lg={8}>
                  {selectedPromo.slider?.bannerImageInfo?.imageS3 ?
                    <img
                      src={selectedPromo.slider?.bannerImageInfo?.imageS3}
                      alt="Banner Image"
                      className="max-w-full"
                    /> :
                    <p>No Image</p>}
                </Grid>
              </Grid>
            }
            {tabIndex === 1 &&
              <div className="px-8">
                {!selectedPromo.socialImages.length ?
                  <p>No Image</p>
                  :
                  selectedPromo.socialImages.map((url, idx) => {
                    return (
                      <Grid container className="h-full" key={`social-image-${idx}`}>
                        <Grid item xs={12} md={6}>
                          <img src={url} alt="Social Image" className="max-w-full" />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className="w-full h-full flex-column items-center justify-center">
                            <FacebookShareButton
                              url={url}
                              className="w-full max-w-150 rounded my-4"
                            >
                              <Button
                                className="flex items-center"
                                variant="contained"
                                color="primary"
                                component="div"
                              >
                                <Icon className="mr-2">facebook</Icon>
                                <span>Share</span>
                              </Button>
                            </FacebookShareButton>
                            <Button
                              className="w-full max-w-150 flex items-center rounded my-4"
                              variant="contained"
                              color="primary"
                              onClick={() => handleDownload(url)}
                            >
                              <Icon className="mr-2">cloud_download</Icon>
                              <span>Download</span>
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    );
                  })}
              </div>
            }
            {/* {tabIndex === 2 &&
              <PrintPromoPdf selectedPromo={selectedPromo} />//     we will work on new PDF generator in future
            } */}
          </Card>
        </div>
      </div>
      <BackdropCircular loading={loadingSinglePromo} />
    </div>
  );
};

export default PromoDetails;
